import type {ReactElement} from 'react';
import type {DesignSelection} from '@Components/social-media/social-media.types';
import type {GraphicsMetaMapType} from '@Components/social-media/publish-params.types';
import type {MediaTypePublishingParams, SocialMediaAccountId} from '@Components/social-media/post.vo';
import type {SocialMediaWizardStep} from '@Components/social-media-wizard/social-media-wizard.types';
import styles from '@Components/social-media-wizard/social-media-wizard.module.scss';

const PREVIEW_SURFACE_SIDE_COUNT = 2;
export const PREVIEW_SURFACE_WIDTH_INSET_PX = Number(styles.previewSurfacePaddingXPx) * PREVIEW_SURFACE_SIDE_COUNT;

export interface WizardPreviewPanelProps {
  wizardStep: SocialMediaWizardStep;
  designsToPublishTo: DesignSelection[];
  postPublishingParams: Record<SocialMediaAccountId, MediaTypePublishingParams>;
  designsGraphicsMetaMap: GraphicsMetaMapType;
  isSelectTemplateFlow: boolean;
  isMobileView: boolean;
  isPreviewLoading: boolean;
  areAllPreviewsUpToDate: boolean;
  ctaSlot: ReactElement | null;
  onPreviewLoaded: VoidFunction;
  onDesignPreviewClick?: VoidFunction;
  containerClasses?: string;
  previewWidthInsetPx?: number;
}
